import { nanoid } from "nanoid";

const DEVICE_ID_STORAGE_KEY = "ts-device-id";

let deviceId: string | null = null;

export const getOrCreateDeviceId = (): string | null => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  if (deviceId) return deviceId;

  try {
    const existingDeviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existingDeviceId) {
      deviceId = existingDeviceId;
      return existingDeviceId;
    }

    const newDeviceId = nanoid(5);
    window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, newDeviceId);
    return newDeviceId;
  } catch (_error) {
    // Accessing localStorage can fail (e.g. in private mode); fall back to no device id.
    return null;
  }
};

export const DEVICE_ID_HEADER = "ts-device-id";
